import React, { useState, ReactNode } from "react";
import { Menu, Tooltip, IconButton } from "@material-ui/core"; 

type DropDownIconButtonProps = {
    buttonTooltipText: string,
    disabled: boolean,
    iconNode: ReactNode,
    childrenNode: ReactNode
   
}

/**
 *  This is a re-usable Component. Provides a drop down icon button with tooltip text. When the icon is clicked, a list of menu display or not 
 */
const DropDownIconButton: React.FunctionComponent<DropDownIconButtonProps> = (props: DropDownIconButtonProps) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleClick = (event: React.MouseEvent<any>) => {
        setAnchorEl(event.currentTarget);    
    }

    return (
        <>
            <Tooltip title={props.buttonTooltipText} placement="bottom-end">
                <span>
                    <IconButton disabled={props.disabled} onClick={handleClick}>
                        {props.iconNode}
                    </IconButton>
                </span>
            </Tooltip>
            <Menu 
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                getContentAnchorEl={null}>
                {props.childrenNode}
          </Menu>
        </>    
    );
}

export default DropDownIconButton;